<hyperkit-dialog class="hyperkit-component" headerText="Export Options">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        <div>
          <hyperkit-typography
            variant="body"
            size="md"
            align="left"
            color="body"
            >Please select the sections you want included in your
            export.</hyperkit-typography
          >
        </div>
        <kendo-treeview
          class="pt-2"
          [nodes]="data"
          textField="text"
          kendoTreeViewHierarchyBinding
          childrenField="items"
          kendoTreeViewCheckable
          [(checkedKeys)]="checkedKeys"
        >
        </kendo-treeview>
        <hyperkit-button
          [disabled]="checkedKeys.length == 0"
          size="small"
          color="tertiary"
          text="Export"
          (click)="onSubmit()"
        ></hyperkit-button>
      </div>
    </div>
  </div>
</hyperkit-dialog>
<ng-template #loading>
  <p>Loading…</p>
</ng-template>
